import placementsJson from '@designwithfriends/common/campaigns/placements.json';

export const PLACEMENTS = placementsJson.placements;
export const PLACEMENT_LABELS = Object.fromEntries(PLACEMENTS.map((p) => [p.id, p.label]));

export const STATUS_OPTIONS = [
    { value: 'draft', label: 'Draft' },
    { value: 'live', label: 'Live' },
    { value: 'paused', label: 'Paused' },
    { value: 'archived', label: 'Archived' },
];

export const PLATFORM_OPTIONS = [
    { value: 'web-desktop', label: 'Web (desktop)' },
    { value: 'web-phone', label: 'Web (phone)' },
    { value: 'pwa', label: 'Installed web app' },
    { value: 'ios', label: 'iOS app' },
    { value: 'android', label: 'Android app' },
];

export const ACCOUNT_OPTIONS = [
    { value: 'guest', label: 'Guest (signed out)' },
    { value: 'free', label: 'Free' },
    { value: 'paid', label: 'Paid' },
];

export const PLAN_OPTIONS = [
    { value: 'Best of both', label: 'Best of both' },
    { value: 'Ads free', label: 'Ads free (deprecated)' },
    { value: 'Premium items', label: 'Premium items (deprecated)' },
];

export const SUBSCRIPTION_STATE_OPTIONS = [
    { value: 'trialing', label: 'Trialing' },
    { value: 'active', label: 'Active' },
    { value: 'cancelling', label: 'Cancelling (ends at period end)' },
    { value: 'lapsed', label: 'Lapsed (used to pay)' },
    { value: 'past_due', label: 'Payment failed (Stripe retrying, premium paused)' },
];

export const EMAIL_VERIFIED_OPTIONS = [
    { value: 'any', label: 'Any' },
    { value: 'unverified', label: 'Not verified yet' },
    { value: 'verified', label: 'Verified' },
];

export const USES_APP_OPTIONS = [
    { value: 'any', label: 'Any' },
    { value: 'no', label: 'Never signed in on the app' },
    { value: 'yes', label: 'Has signed in on the app' },
];

export const STORE_OPTIONS = [
    { value: 'ios', label: 'App Store' },
    { value: 'android', label: 'Google Play' },
];

export const PROVIDER_OPTIONS = [
    { value: 'stripe', label: 'Stripe (web)' },
    { value: 'apple', label: 'Apple' },
    { value: 'google', label: 'Google Play' },
];

export const ENGAGEMENT_METRICS = [
    { key: 'signupDays', label: 'Days since signup' },
    { key: 'streak', label: 'Current login streak' },
    { key: 'longestStreak', label: 'Longest login streak' },
    { key: 'roomsSaved', label: 'Rooms saved' },
    { key: 'renders', label: 'Renders' },
    { key: 'medals', label: 'Medals' },
    { key: 'votes', label: 'Votes' },
    { key: 'coins', label: 'Coin balance' },
    { key: 'purchases', label: 'Purchases' },
    { key: 'lastSeenDays', label: 'Days since previous login' },
];

export const FORMAT_OPTIONS = [
    { value: 'dialog', label: 'Dialog' },
    { value: 'sheet', label: 'Bottom sheet' },
];

export const THEME_OPTIONS = [
    { value: 'light', label: 'Light' },
    { value: 'hero', label: 'Hero' },
];

export const BLOCK_TYPES = [
    { type: 'image', label: 'Image' },
    { type: 'icon', label: 'Icon' },
    { type: 'eyebrow', label: 'Eyebrow' },
    { type: 'heading', label: 'Heading' },
    { type: 'text', label: 'Text' },
    { type: 'bullets', label: 'Bullets' },
    { type: 'reward', label: 'Reward' },
    { type: 'countdown', label: 'Countdown' },
    { type: 'avatar_items', label: 'Avatar items' },
    { type: 'spacer', label: 'Spacer' },
    { type: 'sale', label: 'Sale' },
    { type: 'store_buttons', label: 'Store buttons' },
];
export const BLOCK_LABELS = Object.fromEntries(BLOCK_TYPES.map((b) => [b.type, b.label]));

export const IMAGE_ASPECT_OPTIONS = [
    { value: 'wide', label: 'Wide' },
    { value: 'square', label: 'Square' },
    { value: 'tall', label: 'Tall' },
    { value: 'original', label: 'Original' },
];

export const TEXT_ALIGN_OPTIONS = [
    { value: 'center', label: 'Center' },
    { value: 'start', label: 'Start' },
];

export const SPACER_SIZE_OPTIONS = [
    { value: 'sm', label: 'Small' },
    { value: 'md', label: 'Medium' },
    { value: 'lg', label: 'Large' },
];

export const BUTTON_STYLE_OPTIONS = [
    { value: 'primary', label: 'Primary' },
    { value: 'secondary', label: 'Secondary' },
    { value: 'link', label: 'Link' },
];

export const ACTION_TYPE_OPTIONS = [
    { value: 'dismiss', label: 'Dismiss' },
    { value: 'navigate', label: 'Go to a page' },
    { value: 'open_url', label: 'Open a URL' },
    { value: 'open_wallet', label: 'Open the wallet' },
    { value: 'open_challenge', label: 'Open a challenge' },
    { value: 'request_review', label: 'Ask for a store review' },
    { value: 'open_store', label: 'Open a store listing' },
    { value: 'watch_ad', label: 'Play a rewarded ad' },
    { value: 'open_signup', label: 'Open sign-up (website guests)' },
    { value: 'update_payment_method', label: 'Open the update-card page (Stripe)' },
];

export const ICON_HELP = 'Name of an icon from common/icons (case-insensitive): Bell, Gift, Trophy, Crown, Flame, Heart, Info, Warning, Coin…';
export const EMOJI_HELP = 'Drawn where an app or the web does not know the icon name, or when no name is set. One emoji.';

export const MAX_BLOCKS = 12;
export const MAX_BUTTONS = 3;

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm';

export const newBlock = (type) => {
    switch (type) {
        case 'image': return { type, url: '', alt: '', aspect: 'wide' };
        case 'icon': return { type, token: 'Gift' };
        case 'eyebrow': return { type, text: '' };
        case 'heading': return { type, text: '' };
        case 'text': return { type, md: '', align: 'center' };
        case 'bullets': return { type, items: [{ icon: '', md: '' }] };
        case 'reward': return { type, coins: null, gems: null, avatarItemId: null, label: '' };
        case 'countdown': return { type, until: null, label: '' };
        case 'avatar_items': return { type, ids: [] };
        case 'spacer': return { type, size: 'md' };
        case 'sale': return { type, label: '' };
        default: return { type };
    }
};

export const newButton = (style = 'primary') => ({ label: '', action: { type: 'dismiss' }, style, platforms: [] });

export const defaultContent = () => ({
    format: 'dialog',
    theme: 'light',
    accent: null,
    confetti: false,
    dismissible: true,
    blocks: [newBlock('heading'), newBlock('text')],
    buttons: [{ ...newButton('primary'), label: 'Got it' }],
});

export const defaultFrequency = () => ({ maxShows: 1, minHoursBetween: 24, maxDismissals: null, stopAfterCta: true });

export const emptyAudience = () => ({
    platforms: [],
    minAppVersion: '',
    maxAppVersion: '',
    accounts: [],
    plans: [],
    subscriptionStates: [],
    providers: [],
    countries: [],
    languages: [],
    engagement: {},
    emailVerified: null,
    usesApp: null,
    seenCampaignIds: [],
    notSeenCampaignIds: [],
    rolloutPercent: 100,
});

export const SALE_KIND_OPTIONS = [
    { value: '', label: 'No sale' },
    { value: 'premium', label: 'Premium discount' },
    { value: 'packs', label: 'Packs discount' },
    { value: 'trial', label: 'Longer free trial' },
];

export const emptySale = () => ({
    kind: '',
    percentOff: null,
    salePriceLabel: '',
    trialDays: null,
    stripe: { couponId: '', priceId: '' },
    apple: { offerIdentifier: '', productIds: {} },
    google: { offerId: '', productIds: {} },
});
export const SALE_KIND_LABELS = Object.fromEntries(SALE_KIND_OPTIONS.filter((o) => o.value).map((o) => [o.value, o.label]));
